var map = {
	"./music-instructions.json": 3087,
	"./music-library-intro2024.json": 3088,
	"./music-library-launch2024.json": 3089,
	"./music-progression.json": 3090,
	"./startSourcesAdvanced.json": 3091,
	"./startSourcesSimple.json": 3092,
	"./startSourcesSimple2.json": 3093,
	"./startSourcesTracks.json": 3094
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2866;